import { Icon, IconSize, Box } from '@bechtel/gds';
import { AppPermissionScope, AuthScope } from '@bechtel/types';
import styled, { css } from 'styled-components';
import { CustomAuthScope } from '../../types';
import { headerColumnWidth } from '../styled';

export const ModuleRowStyled = styled.tr`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    font-size: ${theme.fontSizes[200]};
    font-family: ${theme.fontFamilies['graphik']};
    color: ${theme.colors.grey[1000]};
    font-weight: ${theme.fontWeights[600]};
  `}
`;
export const PermissionRowStyled = styled(ModuleRowStyled)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    font-weight: normal;
  `}
`;

export const PermissionStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  p: { sm: '550' },
})`
  ${({ theme }) =>
    css`
      padding-left: calc(${theme.spacings[600]} + ${theme.spacings[550]});
      border-bottom: solid 1px ${theme.colors.grey[300]};
      border-right: solid 1px ${theme.colors.grey[300]};
    `}
`;

export const StickyColumnStyled = styled.td`
  position: sticky;
  top: 0;
  left: 0;
  width: ${headerColumnWidth};
`;

export const ExpandCollapseIconStyled = styled(Icon).attrs({ size: IconSize.MEDIUM })`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[450]};
    color: ${theme.colors.bechtel.blue[800]};
  `}
`;

export const ModuleStyled = styled(Box).attrs({ p: { sm: '500' }, alignItems: { sm: 'center' } })`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
    border-right: solid 1px ${theme.colors.grey[300]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: calc(${theme.spacings[500]} + ${theme.spacings[100]} / 2);
    padding-bottom: calc(${theme.spacings[500]} + ${theme.spacings[100]} / 2);
    cursor: pointer;
  `}
`;

export const RolePermissionStyled = styled(Box).attrs({ py: { sm: '400' } })`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

interface PermissionGroupStyledProps {
  selectedScope: AppPermissionScope;
}

function getPermissionGroupStyle({ selectedScope }: PermissionGroupStyledProps) {
  switch (selectedScope.id) {
    case AuthScope.MY_WORK_PACKAGES:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
    case AuthScope.ALL_WORK_PACKAGES:
      return css`
        background-color: ${({ theme }) => theme.colors.green[400]};
      `;
    case AuthScope.MY_AREA || AuthScope.ALL_AREA:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[400]};
      `;
    case CustomAuthScope.NONE:
      return css`
        color: ${({ theme }) => theme.colors.grey[1000]};
        background-color: ${({ theme }) => theme.colors.white};
      `;
    case AuthScope.APPLICATION:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[400]};
      `;
    case CustomAuthScope.MULTIPLE:
      return css`
        ${({ theme }) => `
          background-color: ${theme.colors.bechtel.blue[600]};
          padding-top: calc(${theme.spacings[400]} + ${theme.spacings[100]});
          padding-bottom: calc(${theme.spacings[400]} + ${theme.spacings[100]});
        `}
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[400]};
      `;
  }
}

export const PerissionGroupStyled = styled(Box).attrs({
  pl: { sm: '400' },
  pr: { sm: '500' },
  alignItems: { sm: 'center' },
  flexGrow: { sm: 1 },
  py: { sm: '450' },
})<PermissionGroupStyledProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    white-space: nowrap;
    font-size: ${theme.fontSizes[200]};
    font-family: ${theme.fontFamilies['graphik']};
    color: ${theme.colors.white};
    font-weight: ${theme.fontWeights[600]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `};
  ${getPermissionGroupStyle}
`;
